import { type SelectionBarActions } from '~/components/v2/components/shared/selectionBar/selectionBarActions';

/** Visible CTA copy for the selection bar Share / showcase action. */
export const getSelectionBarShareActionLabel = (share: NonNullable<SelectionBarActions['share']>): string => {
  if (share.kind === 'collection' && share.collectionItemCount !== undefined) {
    return `Share ${share.collectionItemCount}`;
  }

  return 'Share';
};
